/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { AdminNewsDetailFragmentDoc } from './AdminNewsDetail.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AdminNewsDetailPageQueryVariables = Exact<{
  id: string | number;
}>;


export type AdminNewsDetailPageQuery = { newsForPlannerById: { id: string, title: string, body: string, publishedAt: TimeString } };


export const AdminNewsDetailPageDocument = gql`
    query AdminNewsDetailPage($id: ID!) {
  newsForPlannerById(id: $id) {
    ...AdminNewsDetail
  }
}
    ${AdminNewsDetailFragmentDoc}`;

/**
 * __useAdminNewsDetailPageQuery__
 *
 * To run a query within a Vue component, call `useAdminNewsDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminNewsDetailPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminNewsDetailPageQuery({
 *   id: // value for 'id'
 * });
 */
export function useAdminNewsDetailPageQuery(variables: AdminNewsDetailPageQueryVariables | VueCompositionApi.Ref<AdminNewsDetailPageQueryVariables> | ReactiveFunction<AdminNewsDetailPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminNewsDetailPageQuery, AdminNewsDetailPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminNewsDetailPageQuery, AdminNewsDetailPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminNewsDetailPageQuery, AdminNewsDetailPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminNewsDetailPageQuery, AdminNewsDetailPageQueryVariables>(AdminNewsDetailPageDocument, variables, options);
}
export function useAdminNewsDetailPageLazyQuery(variables?: AdminNewsDetailPageQueryVariables | VueCompositionApi.Ref<AdminNewsDetailPageQueryVariables> | ReactiveFunction<AdminNewsDetailPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminNewsDetailPageQuery, AdminNewsDetailPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminNewsDetailPageQuery, AdminNewsDetailPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminNewsDetailPageQuery, AdminNewsDetailPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminNewsDetailPageQuery, AdminNewsDetailPageQueryVariables>(AdminNewsDetailPageDocument, variables, options);
}
export type AdminNewsDetailPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminNewsDetailPageQuery, AdminNewsDetailPageQueryVariables>;